// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3B01G","title":"AfterBackImages_title__2ErcE","images":"AfterBackImages_images__3pB_v"};